import {message} from 'antd';
import {querySerialNumberInfo} from '@api/core/serialNumber';
import PageAdd from './PageAdd';

class PageEdit extends PageAdd {
  componentDidMount() {
    this.getSerialNumber();
  }

  getSerialNumber = () => {
    querySerialNumberInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };
}

export default PageEdit;



// WEBPACK FOOTER //
// ./src/components/boss/serialNumber/PageEdit.js